export default __webpack_public_path__ + "static/media/include_9@3x.8201c25a.jpg";